import type { UserAttributeDef, UserAttributeDefs } from '../../types/ModelTypes'

export type AddressType = {
  dwelling_number: string
  street_number: string
  suburb: string
  city: string
  country: string
  post_code: string
}

const Address: UserAttributeDefs & { [k in keyof AddressType]: UserAttributeDef } = {
  dwelling_number: {
    type: 'String',
    editable: true,
    validation: {
      pass: false,
      invalidMessage: 'Name cannot contain pertempter',
    },
  },
  street_number: {
    type: 'String',
    editable: true,
    validation: {
      pass: false,
      invalidMessage: 'Name cannot contain pertempter',
    },
  },
  suburb: {
    type: 'String',
    editable: true,
    validation: {
      pass: false,
      invalidMessage: 'Name cannot contain pertempter',
    },
  },
  city: {
    type: 'String',
    editable: true,
    validation: {
      pass: false,
      invalidMessage: 'Name cannot contain pertempter',
    },
  },
  country: {
    type: 'String',
    editable: true,
    validation: {
      pass: false,
      invalidMessage: 'Name cannot contain pertempter',
    },
  },
  post_code: {
    type: 'String',
    editable: true,
    validation: {
      pass: false,
      invalidMessage: 'Name cannot contain pertempter',
    },
  },
}

export { Address }
